import {
    Baselayer,
    Ecommerce,
    Taxonomy,
    TrackingContract
} from 'shared/tracking/contracts';

export const mapTracking = (
    taxonomy?: Taxonomy,
    ecommerce?: Ecommerce
): TrackingContract | null => {
    if (typeof window === 'undefined' || !window.analytics) {
        return null;
    }

    const baselayer: Baselayer = {
        session_id: window.__global_base_session_id,
        instance_id: window.__global_base_instance_id,
        device_id: window.__global_base_device_id,
        session_count: window.__global_base_session_count
    };

    const eventData: TrackingContract = {
        baselayer,
        ecommerce
    };

    if (taxonomy) {
        eventData.taxonomy = {
            ...taxonomy,
            path: window.location.pathname
        };
    }

    return eventData;
};
